import { styled } from "@mui/material";

const Container = styled("div")`
  padding: ${({ theme }) => theme.spacing(2)};
  background-color: #e7f0f8;
`;

export { Container };
